module.exports = __webpack_public_path__ + "static/media/Wide Joint Space.8fe929f6.png";